import React from 'react'
import BuildingIcon from '../../../../../../../styles/svg/buildings.svg';
import CheckupIcon from '../../../../../../../styles/svg/checkup-list.svg';
import HomeCheck from '../../../../../../../styles/svg/home-check.svg';
import Exclamation from '../../../../../../../styles/svg/exclamation-circle.svg';
import Calendar from '../../../../../../../styles/svg/fontisto_date.svg';

function Icon({ type }) {
    switch (type) {
        case 'building':
            return <img src={BuildingIcon} alt="building" />;
        case 'checkup':
            return <img src={CheckupIcon} alt="checkup" />;
        case 'home-check':
            return <img src={HomeCheck} alt="home-check" />;
        case 'exclamation':
            return <img src={Exclamation} alt="exclamation" />;
        case 'calendar':
            return <img src={Calendar} alt="calendar" />;
        default:
            return null;
    }
}

export default Icon